export const WorkflowNodeType = {
    Workflow: 'workflow',
    State: 'state',
    Transition: 'transition',
    Action: 'action'
} as const;

export type WorkflowNodeType = typeof WorkflowNodeType[keyof typeof WorkflowNodeType];

/** The type of value assigned to the exit assignee of a workflow transition. */
export enum WorkflowAssigneeType {
    None = "None",
    Unchanged = "Unchanged",
    Role = "Role",
    User = "User",
    ApplicationDataField = "ApplicationDataField",
}
